import NavBarData from 'owa-service/lib/contract/NavBarData';
import getBposShellInfoNavBarDataOperation from 'owa-service/lib/operation/getBposShellInfoNavBarDataOperation';

export default function getBposNavBarDataService(): Promise<NavBarData> {
    return getBposShellInfoNavBarDataOperation();
}
